import React from 'react';
import NestedMenuItem from 'flow/components/ui-components/NestedMenuItem';
import useAppContext from 'flow/hooks/useAppContext';
import AgentProfilePicker from 'flow/components/pbx/supervisor/AgentRow/AgentProfilePicker';
import { ExtensionKey } from 'flow/types/EntityKeys';

interface Props {
    extensionKey: ExtensionKey;
}

const MenuItemAgentProfiles = ({ extensionKey }: Props) => {
    const { i18next } = useAppContext();

    return (
        <NestedMenuItem
            placementDesired={'auto'}
            title={i18next.t('Tooltip.Nav.ProfilePicker')}
        >
            <AgentProfilePicker extensionKey={extensionKey} />
        </NestedMenuItem>
    );
};

export default React.memo(MenuItemAgentProfiles);
